(function () {
  var toggle = document.querySelector(".menu-toggle");
  var menu = document.querySelector(".mobile-menu");
  var close = document.querySelector(".mobile-menu-close");
  if (!toggle || !menu) return;

  var links = menu.querySelectorAll("nav a");

  function open() {
    /* stagger pulito in ordine di DOM; in chiusura i delay si azzerano */
    links.forEach(function (a, i) {
      a.style.transitionDelay = (0.06 + i * 0.055).toFixed(3) + "s";
    });
    menu.classList.add("open");
    toggle.setAttribute("aria-expanded", "true");
  }
  function hide() {
    links.forEach(function (a) {
      a.style.transitionDelay = "0s";
    });
    menu.classList.remove("open");
    toggle.setAttribute("aria-expanded", "false");
  }

  toggle.addEventListener("click", open);
  if (close) close.addEventListener("click", hide);
  menu.querySelectorAll("a").forEach(function (a) {
    a.addEventListener("click", hide);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") hide();
  });
})();
